import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Switch,
  Button,
} from "@mui/material";
import apiRequest from "apiRequest";

function ServiceTable({ services, types, onStatusToggle, onEdit, onDeleteClick }) {
  return (
    <TableContainer component={Paper} style={{ marginTop: "1px" }}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell style={{ fontWeight: "bold" }}>Name</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Type</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Options</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Required</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Photo</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Status</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Actions</TableCell>
          </TableRow>
          {services.map((service) => (
            <TableRow key={service.id}>
              <TableCell>{service.name_en + " / " + service.name_fr}</TableCell>
              <TableCell>
                {service.type ? (types.find((type) => type.value === service.type)?.label || "") : ""}
              </TableCell>
              <TableCell>
                <ul style={{ listStyleType: "disc", paddingLeft: "20px", margin: 0 }}>
                  {(Array.isArray(service.service_options) ? service.service_options : JSON.parse(service.service_options || "[]"))
                    .map((option, index) => {
                      // Support both new structure {name_en, name_fr, price} and legacy single-key objects
                      const hasStructured = option && (option.name_en !== undefined || option.name_fr !== undefined || option.price !== undefined);
                      if (hasStructured) {
                        const en = option.name_en || "";
                        const fr = option.name_fr || "";
                        const price = option.price || "";
                        return (
                          <li key={index}>{`${en} / ${fr}${price !== "" ? ` - ${price}` : ""}`}</li>
                        );
                      }
                      const firstVal = option ? Object.values(option)[0] : "";
                      return <li key={index}>{`${firstVal}`}</li>;
                    })}
                </ul>
              </TableCell>
              <TableCell
                style={{ color : service.is_required === true ? "green" : "red" }}
              >{service.is_required === true ? "Yes" : "No"}</TableCell>
              <TableCell>
                {service.image && (
                  <img
                    src={`${apiRequest.BASE_URL}/${service.image}`}
                    alt={service.name_en}
                    style={{ width: "100px", height: "auto" }}
                  />
                )}
              </TableCell>
              <TableCell>
                <Switch
                  checked={service.status === "active"}
                  onChange={() => onStatusToggle(service.id, service.status)}
                  color="primary"
                />
              </TableCell>
            <TableCell>
  <div style={{ display: "flex" }}>
    <Button
      onClick={() => onEdit(service)}
      color="primary"
      size="small"
      style={{ textTransform: "uppercase" }}
    >
      Edit
    </Button>
    <Button
      onClick={() => onDeleteClick(service.id)}
      color="error"
      size="small"
      style={{ textTransform: "uppercase" }}
    >
      Delete
    </Button>
  </div>
</TableCell>

            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ServiceTable;
